// Single canonical origin for the production site. Every Helmet block,
// JSON-LD builder, sitemap and llms.txt reference must resolve to this value
// (or its literal string in non-TS files) so canonicals never drift between
// bare-domain and www variants.
export const SITE_ORIGIN = "https://www.exosproc.com";

// TAXONOMY / REFERENCE REGISTER
// -----------------------------
// Single source of truth for how EXOS is described as a *class of software*.
// Referenced verbatim (or via CANONICAL_CATEGORY_SHORT) by every taxonomy /
// structured-data / crawler surface: JSON-LD, llms.txt, llms-full.txt,
// glossary and inline positioning paragraphs.
//
// Do NOT paraphrase — replace only via this constant.
export const CANONICAL_CATEGORY_STRING =
  "EXOS is a scenario-based procurement analytics system: it models total cost of ownership, negotiation scenarios and supplier risk before a contract is awarded. It does not replace procure-to-pay or ERP platforms such as Coupa, SAP Ariba or Zip — it operates upstream of them.";

// Short noun-phrase form of the above. Used only where the full sentence
// would break a layout or overflow a 160-char meta description.
// Never invent a third form.
export const CANONICAL_CATEGORY_SHORT = "scenario-based procurement analytics";

// MARKETING / PERSUASIVE REGISTER
// -------------------------------
// Deliberately separate from the taxonomy strings above. This is the hero /
// meta / og persuasive line. It must NEVER appear inside any JSON-LD block,
// llms.txt, llms-full.txt, or any taxonomy definition — those are the
// reference register and must stay factual.
export const MARKETING_TAGLINE = "AI for high-value procurement";

// SCENARIO COUNT — SINGLE SOURCE
// ------------------------------
// The public-facing scenario library count. Standardised as "20+" so that
// growth in the internal catalogue (currently 29 total, 19 fully public)
// does not require a coordinated edit across every marketing surface.
// Every user-visible mention of the count MUST use one of these two
// constants — never hard-code the number in JSX or prose.
export const SCENARIO_COUNT_LABEL = "20+ procurement scenarios";
export const SCENARIO_COUNT_SHORT = "20+ scenarios";
// Bare number token ("20+"). Use this instead of
// SCENARIO_COUNT_SHORT.split(" ")[0] so the split is never repeated in JSX.
export const SCENARIO_COUNT_NUMBER = "20+";

// AUTHOR ENTITY
// -------------
// Content is attributed to the organisation, not to a named individual.
// Referenced by the `author` property of every methodology, glossary and
// blog JSON-LD object. Mirrored literally in index.html and
// scripts/postbuild-seo.mjs — keep the three in sync.
export const AUTHOR_NAME = "EXOS Research Team";

export const AUTHOR_ORGANIZATION_SCHEMA = {
  "@type": "Organization",
  name: AUTHOR_NAME,
  url: SITE_ORIGIN,
} as const;

/** @deprecated Kept as an alias while call sites migrate. */
export const FOUNDER_PERSON_SCHEMA = AUTHOR_ORGANIZATION_SCHEMA;
